import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { GraduationCap, Star } from "lucide-react";

interface CourseCompletionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  courseTitle?: string;
  gracePeriodDays?: number;
}

export default function CourseCompletionDialog({ open, onOpenChange, courseTitle }: CourseCompletionDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" className="text-center max-w-sm">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-accent-purple/10 rounded-full">
              <GraduationCap className="h-12 w-12 text-accent-purple" />
            </div>
          </div>
          <DialogTitle className="text-2xl">סיימת את הקורס! 🎓</DialogTitle>
          <DialogDescription className="text-base">
            {courseTitle && <span className="font-medium text-foreground">{courseTitle}</span>}
            <br />
            כל הכבוד על ההתמדה!
          </DialogDescription>
        </DialogHeader>

        <div className="py-4 space-y-3">
          <div className="p-4 bg-accent-purple/5 rounded-xl text-sm text-right space-y-2">
            <div className="flex items-center gap-2">
              <Star className="h-4 w-4 text-accent-purple flex-shrink-0" />
              <span>התוכן של הקורס נשאר נגיש אליך תמיד</span>
            </div>
            <div className="flex items-center gap-2">
              <Star className="h-4 w-4 text-accent-purple flex-shrink-0" />
              {/* Information, not an instruction: there's no button to act on here
                  (and on native a purchase link would be steering). */}
              <span>המנוי פותח גם את האתגרים הקהילתיים</span>
            </div>
          </div>
          {/* Removed: "יש לך N ימים לנצל את ההצעה לפני שהגישה תיחסם". It
              contradicted the line above — a bought course is kept forever —
              and offered nothing to act on. */}
        </div>

        <DialogFooter className="flex flex-col gap-2">
          {/* TODO: Add subscribe button once subscription link is configured */}
          <Button
            variant="ghost"
            className="w-full"
            onClick={() => onOpenChange(false)}
          >
            סגירה
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
